<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Accounts</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Accounts</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <button class="btn btn-info" data-toggle="modal" data-target="#modal">Add New User</button>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Organization</th>
                    <th>Account</th>
                    <th>Enabled</th>
                    <th>Role</th>
                    <th>Downloads</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in users" :key="user.id">
                    <td>{{user.id}}</td>
                    <td>{{user.name}}</td>
                    <td>{{user.username}}</td>
                    <td>{{user.organization}}</td>
                    <td>{{user.account}}</td>
                    <td class="checkbox-icon pt-0 disabled-click">
                      <label class="checkbox-container">
                        <input :checked="user.is_enabled" type="checkbox">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td>{{user.role}}</td>
                    <td>{{user.downloads}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteUser(user.id)" aria-hidden="true"></i>
                      <i class="fa fa-pencil-alt fa-icons ml-md-3" @click="editedUser = JSON.parse(JSON.stringify(user))" aria-hidden="true" data-toggle="modal" data-target="#edit-modal"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
    <UserModal></UserModal>
    <EditUserModal v-if="editedUser" :user="editedUser" :key="editedUser.id"></EditUserModal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import UserModal from '@/components/UserModal'
import EditUserModal from '@/components/EditUserModal'
import User from '@/models/user'
export default {
  name: 'Accounts',
  components: {
    UserModal,
    EditUserModal
  },
  data () {
    return {
      datatable: null,
      users: [],
      editedUser: null
    }
  },
  computed: {
    isLoading () {
      if (this.users.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchAllUsers()
  },
  methods: {
    fetchAllUsers () {
      this.users = []
      this.$store.dispatch('fetchAllUsers')
        .then((result) => {
          result.data.users.forEach(user => {
            this.users.push(new User(user))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteUser (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this account?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteUser', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllUsers()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 4,
          'orderable': false
        }],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Accounts.vue